import React, { lazy } from 'react';
import { PageNotFound } from '@/layout/common-pages';
import ProtectedRoute from '@/router/components/ProtectedRoute';
import { ROUTES } from '@/constants/routes';

// Lazy loaded components
const AlertPage = lazy(() => import('@/pages/alerts'));
const AlertDetails = lazy(
  () => import('@/pages/alerts/alert-details/AlertDetails'),
);

/**
 * Alert-related routes configuration
 */
export const alertRoutes = {
  path: ROUTES.ALERTS,
  element: <ProtectedRoute component={AlertPage} />,
  children: [
    {
      path: ROUTES.ALERT_DETAILS,
      element: <ProtectedRoute component={AlertDetails} />,
    },
    {
      path: ROUTES.ALERT_DETAILS_NO_DATA,
      element: <PageNotFound />,
    },
  ],
};
